<template>
	<app-page>
		<app-tabs app :tabs="tabs">
			<template v-slot:tab-item="{ tab }">
				<app-tab-item :tab="tab" value="pages">
					<app-heading :title="`${template.name} Fixed Pages`">
						<template v-slot:left>
							<app-button v-if="$ravello.can('website.post')"
								class="d-none d-sm-inline-flex"
								color="success"
								small
								outlined
								:to="{ name: 'website-template-page', params: { page: 'new' } }"
							>Add Fixed Page</app-button>
						</template>
					</app-heading>
					<app-row>
						<app-cell>
							<app-data-table
								:items="pages"
								:headers="headers"
								:total="count"
								:refresh.sync="refresh"
								:initial-state="tableState"
								@update="fetchPages"
							>
								<template v-slot:actions="{ item }">
									<app-button
										v-if="$ravello.can('websitetemplate.put')"
										color="secondary"
										:to="{ name: 'website-template-page', params: { page: item._id } }"
										icon="fa-pencil-alt"
										table
									>
										Edit
									</app-button>
									<app-button-confirm
										v-if="$ravello.can('websitetemplate.delete')"
										color="error"
										icon="fa-trash"
										table
										label-confirm="Remove"
										:description="`Are you sure you want to remove fixed page <b>${item.name}</b>?`"
										title="Remove Page"
										@click="onDelete(item._id)"
									>
										Remove
									</app-button-confirm>
								</template>
							</app-data-table>
						</app-cell>
					</app-row>
					<app-floating-button
						class="d-inline-flex d-sm-none"
						:to="{ name: 'website-template-page', params: { page: 'new' } }"
						color="success"
						icon="fa-plus"
					/>
				</app-tab-item>
			</template>
		</app-tabs>
	</app-page>
</template>

<script>
import { websiteTemplateContentTabs } from '@/datasources/tabs'
import { filters, tableState } from '@/mixins'

export default {
	mixins: [filters, tableState],
	data() {
		return {
			template: {
				name: '',
				slug: '',
			},
			tabs: [],
			pages: [],
			count: -1,
			refresh: false,
			headers: [{
				text: 'Slug',
				value: 'slug',
				sortable: true,
			}, {
				text: 'Name',
				value: 'name',
				sortable: true,
			}, {
				text: 'URL',
				value: 'url',
				sortable: true,
			}, {
				text: 'Version',
				value: 'version',
				sortable: true,
			}, {
				text: 'Actions',
				value: 'actions',
				align: 'end',
				width: '20%',
				sortable: false,
			}],
		}
	},
	computed: {
		templateId() {
			return this.$route.params.template
		},
	},
	async mounted() {
		this.parent = await this.$ravello.graphql('websitetemplate', this.templateId)
			.fields(['name', 'slug'])
			.query()

		this.tabs = websiteTemplateContentTabs(this.templateId)
	},
	methods: {
		async fetchPages(pagination) {
			this.updateTableState(pagination)

			const request = this.$ravello.graphql('pages')
				.parent(this.$ravello.graphql('websitetemplate', this.templateId))
				.fields(['_id', 'name', 'slug', 'url', 'version'])
				.fromPagination(pagination)

			if (this.count === -1) {
				request.count('count')
			}

			try {
				this.pages = await request.query()
				if (this.count === -1) {
					this.count = request.results.count
				}
			} catch (err) {
				this.$notifications.pushAlert('error', err.data.message)
			}
		},

		async onDelete(id) {
			this.$store.dispatch('app/startLoading')
			try {
				await this.$ravello.request()
					.v(2)
					.to('websitetemplates')
					.to(this.templateId)
					.to('pages')
					.to(id)
					.delete()

				this.refresh = true
			} catch (err) {
				this.$notifications.pushAlert('error', err.data.message)
			}
			this.$store.dispatch('app/stopLoading')
		},
	},
}
</script>
